import { pledgeApi, type PostPledgePledgeClaimCancelledPayload, queryClient } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

export const usePledgeClaimCancelledQuery = () => {
	return useMutation({
		mutationFn: async ({ data }: { data: PostPledgePledgeClaimCancelledPayload }) => {
			return await (await pledgeApi).postPledgePledgeClaimCancelled(data);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['pledge-teams'] });
			queryClient.invalidateQueries({ queryKey: ['user-pledge-activity-summary'] });
		}
	});
};
